import type { RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/pinia/auth'

// Sends anyone without a valid session on a requiresAuth route to Keycloak. Kept out of
// router.ts so it can be tested without building the router.
export async function authGuard(to: RouteLocationNormalized) {
  if (!to.meta.requiresAuth) return
  const authStore = useAuthStore()
  // Check in-memory user first; fall back to session storage only when null.
  const user = authStore.user ?? (await authStore.getUser())
  if (user && !user.expired) return
  try {
    // Preserve the target URL (incl. any query params) across the Keycloak
    // round-trip so Redirect.vue can restore it instead of dropping to /home.
    // /realm is exempt: it is the post-logout landing page, not a place the
    // user asked to go, so returning to it would strand customer-subdomain
    // users on the realm picker. Let Redirect.vue resolve the realm instead.
    await authStore.signinRedirect(to.name === 'realm' ? undefined : to.fullPath)
  } catch (e) {
    console.error('signinRedirect failed', e)
  }
  // The browser is on its way to Keycloak (or the redirect failed): don't render the route.
  return false
}
